<template>
    <div class="row mt-4">
        <ul class="tabs-wrapper">
            <li
                class="tab"
                :class="selected === 'Sales' ? 'active' : ''"
                v-if="isTabVisible('sales') && salesCount > 0"
            >
                <a href="javascript:;" @click="setTab('sales')">
                    Sales
                    <span class="badge badge-danger">{{ salesCount }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Quotes' ? 'active' : ''"
                v-if="isTabVisible('quotes') && totalQuotes > 0"
            >
                <a href="javascript:;" @click="setTab('quotes')">
                    Quotes
                    <span class="badge badge-danger">{{ totalQuotes }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Open Sales Orders' ? 'active' : ''"
                v-if="isTabVisible('open_sales_orders') && totalOpenSalesOrders > 0"
            >
                <a href="javascript:;" @click="setTab('open_sales_orders')">
                    OSO
                    <span class="badge badge-danger">{{ totalOpenSalesOrders }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Open Purchase Orders' ? 'active' : ''"
                v-if="isTabVisible('open_purchase_orders') && totalOpenPurchaseOrders > 0"
            >
                <a href="javascript:;" @click="setTab('open_purchase_orders')">
                    OPO
                    <span class="badge badge-danger">{{ totalOpenPurchaseOrders }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Vendor' ? 'active' : ''"
                v-if="isTabVisible('vendor') && totalVendor > 0"
            >
                <a href="javascript:;" @click="setTab('vendor')">
                    Vendor
                    <span class="badge badge-danger">{{ totalVendor }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Inventory' ? 'active' : ''"
                v-if="isTabVisible('inventory') && totalInventory > 0"
            >
                <a href="javascript:;" @click="setTab('inventory')">
                    Inventory
                    <span class="badge badge-danger">{{ totalInventory }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Parts (Various Sources)' ? 'active' : ''"
                v-if="isTabVisible('parts') && totalParts > 0"
            >
                <a href="javascript:;" @click="setTab('parts')">
                    Live Search
                    <span class="badge badge-danger">{{ totalParts }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'ILS' ? 'active' : ''"
                v-if="isTabVisible('ils') && totalISL > 0"
            >
                <a href="javascript:;" @click="setTab('ils')">
                    ILS
                    <span class="badge badge-danger">{{ totalISL }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Marketplace Parts' ? 'active' : ''"
                v-if="isTabVisible('marketplace_parts') && totalMarketplaceParts > 0"
            >
                <a href="javascript:;" @click="setTab('marketplace_parts')">
                    Marketplace Parts
                    <span class="badge badge-danger">{{ totalMarketplaceParts }}</span>
                </a>
            </li>
            <li
                class="tab"
                :class="selected === 'Google Search' ? 'active' : ''"
                v-if="isTabVisible('google_search') && totalGoogleSearch > 0"
            >
                <a href="javascript:;" @click="setTab('google_search')">
                    Google Search
                    <span class="badge badge-danger">{{ totalGoogleSearch }}</span>
                </a>
            </li>
            <!-- <li class="tab" :class="selected === 'Substitutes' ? 'active' : ''" v-if="totalSubstitutes > 0">
                <a href="javascript:;" @click="setTab('substitutes')">
                    Substitutes
                    <span class="badge badge-danger">{{ totalSubstitutes }}</span>
                </a>
            </li> -->
            <li
                class="tab"
                :class="selected === 'Stats' ? 'active' : ''"
                v-if="isTabVisible('stats') && totalStats > 0"
            >
                <a href="javascript:;" @click="setTab('stats')">
                    Stats
                    <span class="badge badge-danger">{{ totalStats }}</span>
                </a>
            </li>

            <li
                class="tab"
                :class="selected === 'Notes' ? 'active' : ''"
                v-if="isTabVisible('notes') && totalNotes > 0"
            >
                <a href="javascript:;" @click="setTab('notes')">
                    Notes
                    <span class="badge badge-danger">{{ totalNotes }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'SearchTabs',
        emits: ['setTab'],
        props: {
            selected: {
                type: String,
                default: 'sales',
            },
            salesCount: {
                type: Number,
                default: 0,
            },
            totalQuotes: {
                type: Number,
                default: 0,
            },
            totalOpenSalesOrders: {
                type: Number,
                default: 0,
            },
            totalOpenPurchaseOrders: {
                type: Number,
                default: 0,
            },
            totalVendor: {
                type: Number,
                default: 0,
            },
            totalInventory: {
                type: Number,
                default: 0,
            },
            totalISL: {
                type: Number,
                default: 0,
            },
            totalMarketplaceParts: {
                type: Number,
                default: 0,
            },
            totalGoogleSearch: {
                type: Number,
                default: 0,
            },
            totalParts: {
                type: Number,
                default: 0,
            },
            totalSubstitutes: {
                type: Number,
                default: 0,
            },
            totalStats: {
                type: Number,
                default: 0,
            },
            totalNotes: {
                type: Number,
                default: 0,
            },
            hiddenTabs: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            isTabVisible(tab) {
                return !this.hiddenTabs.includes(tab)
            },
            setTab(tab) {
                this.$emit('setTab', tab)
            },
        },
    }
</script>

<style scoped>
    .tabs-wrapper {
        display: flex;
        justify-content: flex-start;
        gap: 0.5rem;
        flex-wrap: wrap;
        padding: 0;
        margin: 15px;
        list-style: none;
        position: relative;
        z-index: 1;
        margin-top: 0;
    }

    .tab {
        margin: 0;
        padding: 0;
    }

    .tab a {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        padding: 0.55rem 0.9rem;
        border-radius: var(--radius-pill);
        color: var(--color-text-secondary);
        text-decoration: none;
        font-weight: 600;
        line-height: 1;
        white-space: nowrap;
        background: var(--color-surface-canvas);
        border: 1px solid transparent;
        box-shadow: var(--shadow-xs);
        transition:
            background 0.15s ease,
            color 0.15s ease,
            border-color 0.15s ease,
            box-shadow 0.15s ease,
            transform 0.15s ease;
    }

    .tab a:hover {
        background: var(--color-surface-subtle);
        color: var(--color-text-primary);
        transform: translateY(-1px);
    }

    .tab.active a {
        background: var(--color-accent-soft);
        color: var(--color-text-primary);
        border-color: var(--color-border-default);
        box-shadow: var(--shadow-sm);
    }

    .badge {
        border-radius: var(--radius-pill);
        padding: 0.2rem 0.5rem;
        vertical-align: middle;
        min-width: 1.65rem;
        line-height: 1.1;
    }
</style>
